"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const LinkBase_1 = require("./LinkBase");
exports.Link = styled_1.default(LinkBase_1.LinkBase) `
  color: ${styled_tools_1.switchProp('linkColor', {
    primary: styled_tools_1.prop('theme.primary'),
    accent: styled_tools_1.prop('theme.accent'),
    gray: styled_tools_1.prop('theme.gray6'),
    light: styled_tools_1.prop('theme.gray1'),
})};
  ${styled_tools_1.prop('theme.fonts.axiformaBold')};
  ${styled_tools_1.prop('theme.fontStyles.body1')};
  text-decoration: none;

  &:hover {
    color: ${styled_tools_1.prop('theme.primaryDark')};
    text-decoration: none;
  }

  &:focus {
    color: ${styled_tools_1.prop('theme.primaryDark')};
    text-decoration: none;
  }

  &:active {
    color: ${styled_tools_1.prop('theme.primaryDark')};
    text-decoration: none;
  }
`;

//# sourceMappingURL=Link.js.map
